<header class="title-header pt-7 flex items-center justify-between">
  <div class="title-content flex items-center gap-2">
    <span class="material-symbols-outlined title-icon">request_quote</span>
    <h1 class="title-text">Facturas</h1>
  </div>
  <!--Agregar facturas-->
  <button class="add-button-top" (click)="openModal()">
    + Agregar facturas
  </button>
</header>

<!-- Subheader -->
<div class="mt-4 flex flex-wrap items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
  <p class="sub-heading-2">
    Total: {{ bills.length }} Facturas
  </p>

  <div class="border border-gray-300 rounded-lg items-center px-3 py-2 bg-white">
    <button class="filter-button" (click)="showFilterModal = true">
      Filtrar
    <span class="material-symbols-outlined text-gray-900 font-medium">filter_alt</span>
    </button>
  </div>
</div>

<!-- Modal de filtros -->
<app-filter-bill-modal
  *ngIf="showFilterModal"
  [currentFilters]="{
    text: filterText,
    startDate: filterStartDate,
    endDate: filterEndDate,
    status: filterStatus}"
  (close)="showFilterModal = false" (applyFilters)="onApplyFilters($event)">
</app-filter-bill-modal>

<!--Filtros activos-->
<div *ngIf="hasActiveFilters()" class="mt-3 flex flex-wrap items-center gap-3 bg-blue-50 border border-blue-200 p-3 rounded-lg text-sm text-blue-900">
  <span class="font-medium flex items-center gap-1">
    <span class="material-symbols-outlined text-blue-600 text-base">
      tune
    </span>
    Filtros aplicados:
  </span>
  <!--Filtro de texto-->
  <span *ngIf="filterText" class="bg-blue-100 text-blue-900 text-sm px-3 py-1 rounded-full flex items-center shadow-sm">
    <span class="material-symbols-outlined text-sm">search</span>
    Nombre: "{{ filterText }}"
  </span>

  <!--Filtro de estatus-->
  <span *ngIf="filterText" class="bg-blue-100 text-blue-900 text-sm px-3 py-1 rounded-full flex items-center shadow-sm">
    <span class="material-symbols-outlined text-sm">assignment_turned_in</span>
    "{{ filterStatus }}"
  </span>

  <!-- Filtro de fechas -->
  <span *ngIf="filterStartDate || filterEndDate" class="bg-blue-100 text-blue-900 text-sm px-3 py-1 rounded-full flex items-center gap-1 shadow-sm">
    <span class="material-symbols-outlined text-sm">calendar_month</span>
    {{ filterStartDate ? (filterStartDate | date:'dd/MM/yyyy') : '...' }} -
    {{ filterEndDate ? (filterEndDate | date:'dd/MM/yyyy') : '...' }}
  </span>

   <!--Limpiar filtros-->
  <button class="ml-2 flex items-center gap-1 clear-filter-button" (click)="clearAllFilters()">
    <span class="material-symbols-outlined text-sm">close</span>
    Limpiar filtros
  </button>
</div>

<!-- Tabla -->
<section class="p-6">
  <table class="w-full border-collapse bg-white rounded-xl shadow">
    <thead class="bg-gray-100 text-gray-900 text-sm">
      <tr>
        <th class="text-left py-3 px-4">Archivo PDF</th>
        <th class="text-left py-3 px-4">Archivo XML</th>
        <th class="text-center py-3 px-4">Estatus</th>
        <th class="text-right py-3 px-4">Prox. Pago</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let b of filteredBills" class="hover:bg-gray-50">
        <td class="text-gray-800 py-3 px-4">{{ b.pdfName }}</td>
        <td class="text-gray-800 py-3 px-4">{{ b.xmlName }}</td>
        <td
          class="py-3 px-4 text-center"
          [ngClass]="{
            'text-red-500': b.status === 'Dada de baja',
            'text-yellow-500': b.status === 'Pendiente',
            'text-green-600': b.status === 'Pagada'
          }"
        >
          {{ b.status }}
        </td>
        <td class="py-3 px-4 text-right">{{ b.payDate }}</td>
      </tr>

      <tr *ngIf="filteredBills.length === 0">
        <td colspan="4" class="text-center py-6 text-gray-400">
          No hay facturas cargadas.
        </td>
      </tr>
    </tbody>
  </table>
</section>

<!-- Modal -->
<app-upload-bill-modal *ngIf="showModal" (close)="closeModal()" (filesUploaded)="handleFilesUpload($event)"></app-upload-bill-modal>
